(() => {
  if (window.mmProductInstalled) return;
  window.mmProductInstalled = true;

  function init(scope = document) {
    scope.querySelectorAll('[data-mm-product-sticky]').forEach((bar) => {
      if (bar.dataset.mmReady) return;
      const form = document.getElementById(bar.dataset.formId);
      const root = form && form.closest('[data-mm-product]');
      const primary = form && form.querySelector('button[name="add"][type="submit"]');
      if (!root || !primary) return;
      bar.dataset.mmReady = 'true';
      const button = bar.querySelector('[data-mm-sticky-button]');
      const selection = bar.querySelector('[data-mm-sticky-selection]');
      const mobile = window.matchMedia('(max-width: 749px)');
      let raf = 0;

      const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
      const blocked = () => primary.disabled || primary.getAttribute('aria-disabled') === 'true' || primary.classList.contains('loading');
      const sync = () => {
        raf = 0;
        if (!root.isConnected) return;
        const rect = primary.getBoundingClientRect();
        const cookie = document.getElementById('shopify-pc__banner');
        const cookieVisible = cookie && cookie.getBoundingClientRect().height > 0;
        const overlay = document.querySelector('dialog[open], [aria-modal="true"][open], .cart__popup-wrapper.is_open, cart-popup[open], cart-popup.active, cart-popup.is-open, cart-notification.active');
        const hidden = !mobile.matches || rect.bottom > 0 || !!cookieVisible || !!overlay || document.body.classList.contains('cart_open');
        if (bar.hidden !== hidden) bar.hidden = hidden;
        const isBlocked = blocked();
        if (button.disabled !== isBlocked) button.disabled = isBlocked;
        const label = primary.querySelector('span')?.textContent.trim() || 'Ajouter au panier';
        setText(button, primary.classList.contains('loading') ? 'Ajout en cours…' : label);
        const selectedOptions = [...root.querySelectorAll('variant-radios input:checked, variant-selects select option:checked')].map((el) => el.value).filter(Boolean);
        const bundle = form.querySelector('[data-lb-native-bundle] input:checked');
        const price = root.querySelector('.lb-native-bundle__offer:has(input:checked) .lb-native-bundle__price');
        const salePrice = root.querySelector('[id^="price-"] .price__sale .price-item--sale');
        const regularPrice = root.querySelector('[id^="price-"] .price__regular .price-item--regular');
        const priceRoot = root.querySelector('[id^="price-"] .price');
        const activePrice = bundle && price ? price : priceRoot?.classList.contains('price--on-sale') ? salePrice : regularPrice;
        const quantity = form.elements.namedItem('quantity');
        const qty = Number(quantity?.value || 1);
        const parts = [...selectedOptions];
        if (qty > 1) parts.push('× ' + qty);
        // Never compute bundle totals independently from the existing offer module.
        if (activePrice && !bundle && qty === 1) parts.push(activePrice.textContent.trim());
        setText(selection, parts.join(' · '));
      };
      const schedule = () => { if (!raf) raf = window.requestAnimationFrame(sync); };
      button.addEventListener('click', () => {
        if (blocked()) return;
        // One native click preserves existing bundle validation, personalization and cart handlers.
        primary.click();
        schedule();
      });
      root.addEventListener('change', schedule);
      root.addEventListener('input', schedule);
      document.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      new MutationObserver(schedule).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'] });
      new MutationObserver(schedule).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
      sync();
    });
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mm-upsell-select]');
    if (!select) return;
    const card = select.closest('[data-mm-upsell-card]');
    const option = select.selectedOptions[0];
    const add = card?.querySelector('add-to-cart');
    const price = card?.querySelector('[data-mm-upsell-price]');
    if (add) add.setAttribute('data-variant-id', select.value);
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
